import React, { useState, useEffect, useRef } from "react";
import cn from "classnames";
import { Link, useNavigate } from "react-router-dom";

/*
//import Slider from "react-slick";
//import styles from "./Hero.module.sass";
//import Icon from "../../../components/Icon";
//import Player from "../../../components/Player";
//import Modal from "../../../components/Modal";
//import Connect from "../../../components/Connect";
//import { useNavigate } from 'react-router-dom';
// import Bid from "../../../components/Bid";
import API from "../../../utils/API";
import { useSelector } from "react-redux";
// import { FormHelperText } from "@material-ui/core";
*/
import { NAMES_CONSTANTS } from '../../../constants';
import downArrowPng from '../../../assets/images/icons/down-arrow.png';
import realSplitLogoUrl from '../../../assets/images/logo/realspilt_logo_white.png';
import rsLogoUrl from '../../../assets/images/logo/RS_icon_white.png';
import UserHeader from '../../../components/Header/UserHeader';
//import InvestNowBanner from '../../../components/InvestNowBanner';


/*
const SlickArrow = ({ currentSlide, slideCount, children, ...props }) => (
    <button {...props}>{children}</button>
);
*/

//const HeroLoreBuilding = () => {
const HeroLoreBuilding = (props) => {

    //const userAccessToken = localStorage.getItem(NAMES_CONSTANTS.USER_ACCESS_TOKEN);
    //const userAccessToken;
    //console.debug('HeroLoreBuilding: userAccessToken = ', userAccessToken);
    //const [userAccessToken, setUserAccessToken] = useState(
    //    localStorage.getItem(NAMES_CONSTANTS.USER_ACCESS_TOKEN)
    //);

    const navigate = useNavigate();
    const sliderRef = useRef();

    let [assets, setAssets] = useState([]);

    useEffect(() => {
        console.debug('HeroLoreBuilding: useEffect(() => {');
        console.debug('    props.assets = ', props.assets);

        //userAccessToken = localStorage.getItem(NAMES_CONSTANTS.USER_ACCESS_TOKEN);
        //console.debug('    userAccessToken = ', userAccessToken);

        setAssets(props.assets);
    }, []);

    /*
    const settings = {
        arrow: false,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        adaptiveHeight: true,
        autoplay: true,
        autoplaySpeed: 4000,
        //nextArrow: (
        //   <SlickArrow>
        //     <Icon name="arrownext" size="20"  fill="black"/>
        //   </SlickArrow>
        //),
        //prevArrow: (
        //   <SlickArrow>
        //     <Icon name="arrowprev" size="20" fill="black"/>
        //   </SlickArrow>
        //),
    };
    */

    //const [visibleModalBid, setVisibleModalBid] = useState(false);
    const [data, setData] = useState([]);
    //const [minutes, setMinutes] = useState(0);
    //const [seconds, setSeconds] = useState(0);
    //const [hour, setHour] = useState(0);
    const [timeArr, setTimeArr] = useState(null);

    //const euroValue = useSelector((state) => state.counter.euroValue) || 0;

    /*
    const getSliderAuctions = (params) => {

        // API.get("/asset/active/auctions")
        API.get("/asset/all?isCarrosel=true&limit=25").then((res) => {
            const data = res.data.result.assets.rows;
            let arr = data?.map(each => {
                let item = each?.asset
                let price = each?.saleType === "fixed"
                    ? each?.isResell === true ? each?.resalePrice : item?.regularPrice
                    : item.auctions?.[0]?.currentBid || item.auctions?.[0]?.openingPrice

                return {
                    title: item.name?.length > 22 ? item.name?.substring(0, 20) + "..." : item?.name,
                    creator: item.creatorName > 24 ? item.creatorName?.substring(0, 22) + "..." : item?.creatorName,
                    //currency: (price * euroValue)?.toFixed(4) + " Matic",
                    price: (price)?.toFixed(4),
                    avatar: "images/userplaceholder.svg",
                    image: item?.thumbnailUrl || item?.mediaPreviewUrl,
                    image2x: item?.thumbnailUrl || item?.mediaPreviewUrl,
                    id: item.id,
                    item,
                    video: item?.mediaPreviewUrl || null,
                    audio: item?.mediaPreviewUrl || null,
                    audioImg: item?.audioThumbnail || null,
                    mediaType: item?.mediaType,
                    creatorName: item?.creatorName,
                    description: item?.shortDescription,
                    assetId: each?.id
                }
            });
            setData(arr);
        });
    }
    */

    function timeLeft(item) {
        if (item?.auction?.endingDate) {
            var now = new Date();
            var diff = new Date(item?.auction?.endingDate) - now;
            var hours = Math.floor(diff / 3.6e6);
            var minutes = Math.floor((diff % 3.6e6) / 6e4);
            var seconds = Math.floor((diff % 6e4) / 1000);
            if (hours < 0 || minutes < 0 || seconds < -1) {
              return { hours: 0, minutes: 0, seconds: 0 }
            }
            return { hours, minutes, seconds }
        }
        return { hours: 0, minutes: 0, seconds: 0 }
    }

    useEffect(() => {

        let params = {
            limit: 20,
            page: 1,
            saleType: "auction"
        };

        //getSliderAuctions(params);

        const getAllData = setInterval(() => {
          setTimeArr(data.map(item => timeLeft(item.item)));
        }, 1000);

        return () => clearInterval(getAllData);

    }, [])

    /*
    const limitTextToCount = (text, count) => {
        return text.slice(0, count) + (text.length > count ? "..." : "");
    }

    const goNext = () => {
        sliderRef.current.slickNext();
    }
    const goPrev = () => {
        sliderRef.current.slickPrev();
    }

    const firstItem = data.length && data[0]
    */

    const clickLearnMore = () => navigate('/item/1');
          
    /*                              
    const scrollToWhatIsRealsplit = () => {
        //window.scrollTo(0, 830);
        window.scrollTo({
              top: 830
            , behavior: 'smooth'
        });
    };
    */

    const headerNav = () => (

        <nav>

            <div className = 'table'>

                <div className = 'row'>

                    <div className = 'cell'>
                        <Link
                            to = '/about'
                            style = {{ cursor: 'pointer', whiteSpace: 'nowrap'}}>
                            About Us
                        </Link>
                    </div>

                    <div className = 'cell'>                    
                        <a
                            href = 'https://docsend.com/v/ksnss/business-plan-community'
                            target = '_blank'>Strategy</a>
                    </div>

                    <div className = 'cell'>
                        <Link
                            to = '/search/all'
                            style = {{
                                cursor: 'pointer'
                                , whiteSpace: 'nowrap'
                                //, backgroundColor: 'rgba(255, 255, 255, 0.25)'
                                //, backgroundColor: 'rgba(0, 0, 0, 0.15)'
                                //, borderRadius: '20px'
                                //, padding: '3px 10px'
                                //, display: 'table-cell'
                            }}>
                            Our Portfolio
                        </Link>
                    </div>

                    <div
                        className = 'cell'
                        >
                        <Link
                            to='/search/all'
                            style = {{
                                cursor: 'pointer'
                                , whiteSpace: 'nowrap'
                                //, backgroundColor: 'rgba(255, 255, 255, 0.25)'
                                //, backgroundColor: 'rgba(0, 0, 0, 0.15)'
                                //, borderRadius: '20px'
                                //, padding: '3px 10px'
                                //, display: 'table-cell'
                            }}>
                            Login
                        </Link>
                    </div>
                </div>
            </div>
        </nav>
    );
    
    return ( <>

        <div
            className = "hero-lore-building"
            style = {{
                  width: "100%"
                //, paddingBottom: "150px"
                //, paddingTop: "88px"
                //, maxWidth: "1130px"
                , margin: "auto"
                //, height: '100vh'
                //, backgroundColor: 'rgba(0,0,0,0.5)'
            }}>

            <div
                className = "site-max-width"
                style = {{
                    width: '100%'
                    , height: '100%'
                    //, backgroundColor: 'rgba(0,0,0,0.2)'
                    //, backgroundColor: 'rgba(255,255,255,0.05)'
                    //, backgroundColor: 'rgba(36,62,119,0.22)'
                    //, backgroundColor: 'rgba(46, 51, 56,0.25)'
                    //, backgroundColor: 'rgba(100, 100, 100,0.3)'
                }}
                >

            <div
                //className = "hero-lore-building"
                //className = "site-max-width"
                className = 'site-max-width-inner'
                //style = {{ maxWidth: "48%", paddingTop: "80px", paddingBottom: "80px" }}
                //style = {{ display: "flex", flexDirection: "row", flexWrap: "wrap" }}
                //style = {{
                //    display: 'flex'
                //    , justifyContent: "center"
                    //, justifyContent: "space-between"
                //    , flexWrap: "wrap"
                //    , flexDirection: "row"
                    //, gap: "33px"
                    //, paddingTop: "108px"
                    //, borderRadius:'5px'
                    //, width: '1200px'
                //    , margin: 'auto'
                    //, height: '100vh'
                    //, width: 'auto'
                    //, maxWidth: '1420px'
                    //, outline: 'blue 2px solid'
                    //, backgroundColor: 'rgba(0,0,0,0.5)'
                //}}
                >

                {/*<InvestNowBanner />*/}

                <div
                    //className = 'site-max-width-inner'
                    className = 'hero-left'
                    style = {{
                        //flex: '0 50%'
                        //flexBasis: '50%'
                        //width: '1200px'
                        //, outline: 'red 2px solid'
                    }}>

                        <div
                            //style = {{
                            //    display: 'table'
                                //, width: '100%'
                                //, maxWidth: '1000px'
                                //, margin: 'auto'
                                //, paddingTop: '150px'
                            //    , paddingLeft: '20px'
                            //}}
                            >

                            <div
                                style = {{ display: 'table-cell' }}
                                >

                                {/*
                                <div
                                    className = 'baskervville-regular'
                                    style = {{
                                        padding: '10px 0px 0px 10px'
                                        , fontSize: '4rem'
                                        , fontWeight: '600'
                                        , color: 'white'
                                    }}>
                                    Your Exclusive
                                    <br/>Live | Work | Play Club
                                </div>
                                */}
                                <div
                                    className = 'baskervville-regular line2'
                                    //style = {{
                                    //    color: 'white'
                                        //, padding: '10px 0px 0px 10px'
                                    //    , paddingTop: '10px'
                                        //, fontSize: '2.2rem'
                                    //    , fontSize: '35px'
                                    //    , fontWeight: '600'
                                    //}}
                                    >
                                    Reinventing Commercial<br/>Real Estate Ownership
                                </div>

                                <div
                                    style = {{
                                        /*
                                        display: 'flex'
                                        , flexDirection: 'row'
                                        , alignItems: 'center'
                                        , flexDirection: 'column'
                                        , justifyContent: 'left'
                                        , alignContent: 'flex-start'
                                        , textAlign: 'left'
                                        */
                                    }}
                                    >

                                    {/*
                                    <img
                                        //src = 'images/logos/RealSplit-Logo-Building-Only-with-Margin_350x350.png'
                                        //src = 'images/logos/RealSplit-Logo-Building-Only_512x512.png'
                                        //src = 'images/logo/RealSplit-Full-Logo-White_392x103.png'
                                        //src = 'images/logo/New-Building-White-Corner_1625x1625.png'
                                        //src = 'images/logo/Realsplit_logo_concepting_06.png'
                                        //src = 'images/logo/Full-Logo-New-Building-with-Calistoga-Font_7000x1625.png'
                                        src = 'images/logo/Full-Logo-New-Building-with-Calistoga-Font-White_7000x1625.png'
                                        style = {{
                                            width: '450px'
                                        //    , maxHeight: '200px'
                                        }}
                                        />

                                    <br/>
                                    */}

                                    {/*
                                    <div
                                        className = 'baskervville-regular'
                                        style = {{
                                            color: 'white'
                                            , fontSize: '60px'
                                            , lineHeight: '60px'
                                            , fontWeight: '600'
                                            , display: 'inline-block'
                                            , margin: 'auto'
                                            , verticalAlign: 'bottom'
                                            , paddingLeft: '20px'
                                            , marginBottom: '-7px'
                                            , textTransform: 'uppercase'
                                            , letterSpacing: '2px'
                                        }}
                                        >
                                        RealSplit
                                    </div>
                                    */}

                                    <div
                                        className = 'baskervville-regular line1'
                                        //style = {{
                                        //    color: 'white'
                                            //, padding: '20px 0px 0px 10px'
                                        //    , paddingTop: '20px'
                                        //    , fontSize: '24px'
                                        //    , fontWeight: '500'
                                        //}}
                                        >
                                        Real Ownership.
                                        <br/>Exclusive Offerings.
                                        <br/>Share in Profits.
                                        {/*
                                        <br/>Exclusive Real World Assets.
                                        <br/>Curated RWA Investment Company
                                        */}
                                    </div>

                                </div>

                                {/*
                                <div
                                    //className = 'baskervville-regular'
                                    style = {{
                                        padding: '10px 0px 0px 10px'
                                        , fontSize: '1.2rem'
                                        , fontWeight: '500'
                                        , color: 'white'
                                        , width: '500px'
                                    }}>
                                    Immerse yourself in prestigious communities next to the world’s largest sporting & concert venues.
                                    LORE is where tradition meets innovation, as our members enjoy exclusive affiliations that refine their social experience and elevate connections. 
                                </div>
                                */}

                                {/*
                                <div style = {{ paddingTop: '30px'}}>
                                    <button
                                        type = 'button'
                                        style = {{
                                            //, border: 'white 2px solid'
                                            //, borderRadius: '0px'
                                            fontSize: '22px'
                                            , borderRadius: '35px'
                                            //, fontWeight: 'bold'
                                            //, backgroundColor: 'var(--color-theme-primary)'
                                            //, backgroundColor: 'rgba(0,0,0,0.5)'
                                            //, backgroundColor: 'rgba(36, 62, 119,0.5)'
                                            , backgroundColor: 'white'
                                            , color: 'var(--color-theme-primary)'
                                        }}
                                        className = 'plain large'
                                        onClick = {() => navigate('/search/all')}
                                        >Find Deals</button>
                                </div>
                                */}

                                {/*
                                <div
                                    className = 'baskervville-regular line1'
                                    style = {{ paddingTop: '30px'}}
                                    >
                                    <button
                                        type = 'button'
                                        //style = {{
                                            //, border: 'white 2px solid'
                                            //, borderRadius: '0px'
                                        //    fontSize: '22px'
                                            , borderRadius: '35px'
                                            //, fontWeight: 'bold'
                                            //, backgroundColor: 'var(--color-theme-primary)'
                                            //, backgroundColor: 'rgba(0,0,0,0.5)'
                                            //, backgroundColor: 'rgba(36, 62, 119,0.5)'
                                        //    , backgroundColor: 'white'
                                        //    , color: 'var(--color-theme-primary)'
                                        //}}
                                        //className = 'plain large'
                                        className = 'theme-sensei'
                                        onClick = {() => navigate('/news/RealSplitLaunches')}
                                        >Latest News</button>
                                </div>
                                */}

                            </div>

                            {/*
                            <div
                                style = {{
                                    color: '#fff'
                                    , fontFamily: 'Times'
                                    , verticalAlign: 'top'
                                    , display: 'table-cell'
                                    , padding: '20px 0px 0px 20px'
                                }}
                                >
                                <img
                                    src = { realSplitLogoUrl }
                                    style = {{
                                        width: '150px'
                                        , verticalAlign: 'top'
                                    }}
                                    />
                                <div
                                    style = {{
                                        padding: '10px 0px 0px 10px'
                                        , fontSize: '28px'
                                        , fontWeight: '200'
                                    }}>
                                    Real Ownership.
                                    <br/>Share in Profits.
                                    <br/>Bluechip Offerings.
                                </div>
                            </div>
                            */}

                        </div>

                    {/*
                    </div>
                    */}

                </div>

                <div
                    className = 'hero-right'
                    //style = {{
                        //paddingTop: '180px'
                        //flex: '0 50%'
                        //flexBasis: '50%'
                        //, paddingLeft: '200px'
                        //, marginRight: '0px'
                        //, marginLeft: 'auto'
                        //, textAlign: 'right'
                    //}}
                    >

                    <div
                        className = 'baskervville-regular'
                        style = {{
                            color: '#fff'
                            //, fontSize: '34px'
                            //, fontFamily: 'Times'
                            //, paddingLeft: '190px'
                            //, outline: 'orange 2px solid'
                            //, marginRight: '0px'
                            //, marginLeft: 'auto'
                            //, display: 'table'
                            //, paddingRight: '30px'
                            //, paddingBottom: '50px'
                        }}>

                        <div
                            id = 'Own-This-Building'
                            //style = {{ display: 'table-row' }}
                            >
                            <div style = {{ display: 'table-cell' }}>

                                <div className = "table">
                                    <div className = "row">
                                        <div className = "cell">
                                            {/*
                                            <Link
                                                to='/lore1'
                                                style = {{ cursor: 'pointer', whiteSpace: 'nowrap', color: 'white', textDecoration: 'none' }}>
                                            */}
                                                Own this building,
                                            {/*
                                            </Link>
                                            */}
                                        </div>
                                    </div>

                                    <div style = {{ display: 'table-row' }}>
                                        <div
                                            style = {{
                                                display: 'table-cell'
                                                //, padding: '8px 0px 8px 0px'
                                            }}>
                                            & profit from every
                                        </div>
                                    </div>

                                    <div style = {{ display: 'table-row' }}>
                                        <div
                                            style = {{
                                                display: 'table-cell'
                                                //, paddingLeft: '170px'
                                            }}>
                                            business inside.
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div style = {{ display: 'table-row' }}>
                            <div
                                style = {{
                                    display: 'table-cell'
                                    //, paddingLeft: '120px'
                                    //, margin: 'auto'
                                    , textAlign: 'center'
                                    , paddingTop: '30px'
                                }}>

                                <Link
                                    to='/item/1'
                                    style = {{ cursor: 'pointer' }}>
                                <img
                                    className = 'lore-logo'
                                    //src = 'images/properties/LORE/LORE-ONLY_white.png'
                                    src = 'images/properties/LORE/LORE-LA_v01_WHITE.png'
                                    //style = {{
                                    //    width: '250px'
                                        //height: '200px'
                                        //, margin: 'auto'
                                    //}}
                                    />
                                </Link>

                                <div
                                    style = {{ padding: '30px 0px' }}
                                    >

                                    <button
                                        //onClick = { (e) => scrollToWhatIsRealsplit() }
                                        onClick = { (e) => clickLearnMore() }
                                        type = 'button plain'
                                        //style = {{
                                            //border: 'white 2px solid'
                                            //, borderRadius: '0px'
                                            //fontSize: '22px'
                                            //, borderRadius: '35px'
                                            //, fontSize: '22px'
                                            //, fontWeight: 'bold'
                                            //, backgroundColor: 'var(--color-theme-primary)'
                                            //, backgroundColor: 'rgba(0,0,0,0.5)'
                                            //, backgroundColor: 'white'
                                            //, color: 'var(--color-theme-primary)'
                                            //, marginTop: '30px'
                                            //, marginLeft: 'auto'
                                            //, marginRight: 'auto'
                                            //, margin: '30px auto'
                                            //, textAlign: 'center'
                                            //padding: '10px 20px'
                                            //, fontSize: '36px'
                                        //}}
                                        //className = 'plain large'
                                        className = 'theme-sensei'
                                        >
                                        View Deal
                                    </button>

                                </div>
                            </div>
                        </div>

                        <div
                            style = {{
                                //display: 'table-row'
                                display: 'none'
                            }}>
                            <div
                                style = {{
                                    display: 'table-cell'
                                    , padding: '50px 0px'
                                }}>

                                <div
                                    style = {{
                                        display: 'flex'
                                        , flexWrap: 'wrap'
                                        //, justifyContent: 'space-evenly'
                                        , justifyContent: 'center'
                                        , gap: '50px'
                                        , alignItems: 'center'
                                        , width: '100%'
                                        , flex: '1'
                                        //, border: 'yellow 3px solid'
                                    }}>
                                
                                        {/*
                                        <button
                                            type = 'button'
                                            style = {{
                                                //, border: 'white 2px solid'
                                                //, borderRadius: '0px'
                                                fontSize: '22px'
                                                , borderRadius: '35px'
                                                //, fontWeight: 'bold'
                                                //, backgroundColor: 'var(--color-theme-primary)'
                                                //, backgroundColor: 'rgba(0,0,0,0.5)'
                                                //, backgroundColor: 'rgba(36, 62, 119,0.5)'
                                                , backgroundColor: 'white'
                                                , color: 'var(--color-theme-primary)'
                                            }}
                                            className = 'plain large'
                                            onClick = {() => navigate('/search/all')}
                                            >Find Deals</button>
                                        */}
                                    
                                        <button
                                            //onClick = { (e) => scrollToWhatIsRealsplit() }
                                            type = 'button plain'
                                            style = {{
                                                //border: 'white 2px solid'
                                                //, borderRadius: '0px'
                                                fontSize: '22px'
                                                //, fontSize: '22px'
                                                //, fontWeight: 'bold'
                                                //, backgroundColor: 'var(--color-theme-primary)'
                                                //, backgroundColor: 'rgba(0,0,0,0.5)'
                                                , backgroundColor: 'white'
                                                , color: 'var(--color-theme-primary)'
                                            }}
                                            className = 'plain large'
                                            >
                                            Learn More
                                            {/*
                                            &nbsp;
                                            <img src = { downArrowPng } />
                                            */}
                                        </button>
                                </div>

                            </div>
                        </div>

                    </div>
                </div>


            </div>
            </div>
        </div>
        
    </>);
};

export default HeroLoreBuilding;
